module.exports = __webpack_public_path__ + "static/media/mononoke.1ee3e055.jpg";